// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__hcg-k","modal":"Modal_modal__ALWqE","slide-down":"Modal_slide-down__B84s-"};